import { Injectable, inject } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { StorageTypeEnum } from '../../models/enums/storage-type.enum';
import { GridsSettingsModel } from '../../models/grids-settings.model';
import { UsersResource } from '../resources/users.resource';

@Injectable({
    providedIn: 'root'
})
export class SettingsSessionStorage extends BaseStorage {
    private userGridsConfigurationKey = 'userGridsConfiguration';
    private hasEncouragedElectronicDeliveryMethodKey = 'hasEncouragedElectronicDeliveryMethod';

    private readonly usersResource = inject(UsersResource);

    constructor() {
        super('settings', StorageTypeEnum.Session);
    }

    getUserGridsConfiguration(): GridsSettingsModel {
        return new GridsSettingsModel(this.get<GridsSettingsModel>(this.userGridsConfigurationKey));
    }

    saveUserGridsConfiguration(config: GridsSettingsModel, saveOnServer = true): void {
        this.save(config, this.userGridsConfigurationKey);

        if (saveOnServer) {
            this.usersResource.saveGridsSettings(config).subscribe();
        }
    }

    getHasEncouragedElectronicDeliveryMethod(): boolean {
        return this.get<boolean>(this.hasEncouragedElectronicDeliveryMethodKey) || false;
    }

    saveHasEncouragedElectronicDeliveryMethod(value: boolean): void {
        this.save(value, this.hasEncouragedElectronicDeliveryMethodKey);
    }

    eraseUserSettings(): void {
        this.clear();
    }
}
